"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMoveToDepartmentModal = void 0;
const modal_form_component_1 = require("../../components/modal.form/modal.form.component");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const org_department_selector_1 = require("../org.department.selector/org.department.selector");
const collection_move_modal_ctrl_1 = require("./collection.move.modal.ctrl");
const collection_move_modal_style_1 = require("./collection.move.modal.style");
(0, theme_1.addStyles)(collection_move_modal_style_1.Style);
class CollectionMoveToDepartmentModal extends modal_form_component_1.ModalFormComponent {
    constructor(ctx, collections) {
        super(ctx);
        this.ctrl = new collection_move_modal_ctrl_1.CollectionMoveModalCtrl(collections);
        this.departmentSelector = new org_department_selector_1.OrgDepartmentSelector({ crossOrganization: true });
        this.addState(this.departmentSelector.inputState);
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: collection_move_modal_style_1.CSS.content }, [
                (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MOVE_CONFIRM, { count: this.ctrl.collections.length })),
                this.departmentSelector.view()
            ])
        ]);
    }
    submit() {
        return this.ctrl.moveCollections(this.departmentSelector.selectedDepartmentId);
    }
}
exports.CollectionMoveToDepartmentModal = CollectionMoveToDepartmentModal;
//# sourceMappingURL=collection.move.modal.js.map